import React from "react";
import { AppRoutes } from "shared/routes/AppRoutes";

export const AppStart = () => {
  return <AppRoutes />;
};
